import React from 'react';
import cn from 'clsx';

import styles from './input-group.scss';

interface InputGroupProps {
  className?: string;
  columnCount?: number;
}

function InputGroup(props: React.PropsWithChildren<InputGroupProps>) {
  const { children, className = '', columnCount } = props;
  const style = columnCount ? { width: `${100 / columnCount}%` } : undefined;

  return (
    <div
      className={cn(styles['container'], `input-group ${className}`)}
      data-testid="input-group"
    >
      {React.Children.map(
        children,
        child =>
          child && (
            <div
              className={cn(styles['cell'], 'input-group__child')}
              style={style}
            >
              {child}
            </div>
          )
      )}
    </div>
  );
}

export default InputGroup;
